import React from 'react';

function RelatedVideo(props) {
    const isVt = props.template && props.template.startsWith("VT_");
    const videoFk = props.vfkey ? (props.vfkey.video_fk || props.vfkey.video_fkey || props.vfkey.videoFk) : null;
    const isActive = Boolean(props.activeVideoFk && videoFk && (props.activeVideoFk === videoFk));
    const displayTitle = props.title || (props.vfkey && (props.vfkey.main_title || props.vfkey.title)) || "Play Video";

    let cardStyle = {
        transform: "translate(" + props.cs + "px)",
        width: props.width - 15,
        marginRight: "15px"
    };

    let posterHeight = (props.width - 15) * 0.56;
    let posterStyle = {
        width: props.width - 15,
        height: posterHeight,
        overflow: "hidden",
        position: "relative"
    };

    if (isVt) {
        return (
            <div
                style={cardStyle}
                className={`card vt-card ${isActive ? 'vt-card-active' : ''}`}
                onClick={function (event) {
                    props.handleLoadVideo(props.vfkey, event);
                    props.handleClickVideo(props.vfkey, event);
                }}
            >
                <div style={posterStyle} className="vt-card-thumb-wrap">
                    <img
                        onLoad={(e) => { e.currentTarget.style.backgroundColor = '#000'; }}
                        className="card-img-top poster vt-poster"
                        src={props.poster}
                        alt={displayTitle}
                    />
                    <div className="vt-card-overlay">
                        <div className="vt-play-center">
                            <span className={`vt-play-circle ${isActive ? 'vt-play-circle-active' : ''}`}>
                                <i className="fa-solid fa-play"></i>
                            </span>
                        </div>
                        <div className="vt-card-bottom-title" title={displayTitle}>
                            {displayTitle}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    let clsNames = "card";
    if (props.preview) {
        clsNames = "card h-100";
    }

    let video = (
        <div style={cardStyle} className={clsNames}>
            <div style={posterStyle}>
                <img
                    onLoad={(e) => { e.currentTarget.style.backgroundColor = '#000'; }}
                    onClick={function (event) {
                        props.handleLoadVideo(props.vfkey, event);
                        props.handleClickVideo(props.vfkey, event);
                    }}
                    className="card-img-top poster"
                    src={props.poster}
                    alt="..."
                />
            </div>
            <div className="card-body">
                <h5 className="card-title">{props.title}</h5>
                <p className="card-text">{props.desc}</p>
            </div>
        </div>
    );

    return video;
}

export default RelatedVideo;


// WEBPACK FOOTER //
// ./src/components/RelatedVideo.js